;
/*!
 * SubitoTexto.blogPostLikes.js
 */
SubitoTexto.blogPostLikes = {
	init      : function () {
		var $ = jqPla,
			_this = SubitoTexto.blogPostLikes;

		_this.$likesContainer = $( '.blogpost-single' ).find( '#likes' );

		// Nothing to do here
		if ( _this.$likesContainer.length < 1 ) {
			return;
		}

		_this.$content = $( '#content' );
		_this.$likeBtns = _this.$likesContainer.find( '.icon-vote' );
		_this.postId = _this.$content.data( 'id' );


		// Check for cookie
		var cookieValue = Cookies.get( 'article-' + _this.postId );

		if ( cookieValue !== undefined ) {
			_this.$likeBtns.filter( '#vote_' + cookieValue ).addClass( 'active' );
			_this.$likesContainer.addClass( 'disabled' );
		}


		_this.bindEvents();
	}, // init()
	bindEvents: function () {
		var $ = jqPla,
			_this = SubitoTexto.blogPostLikes;

		_this.$likesContainer.on( 'click', '.icon-vote', _this.vote );


		_this.$likesContainer.on( 'click', '#show_comments', function ( e ) {
			e.preventDefault();

			PLA.UTILS.scrollTop.scrollTo( $( '#comment_list' ), -20 );
		} );


	}, // bindEvents()
	vote      : function ( e ) {
		var $ = jqPla,
			_this = SubitoTexto.blogPostLikes;

		e.preventDefault();

		if ( _this.$likesContainer.hasClass( 'disabled' ) ) {
			return false;
		}

		var $currentButton = $( this ),
			vote = $currentButton.attr( 'id' ).replace( 'vote_', '' );

		// Set values to send to ajax
		var objData = {
			action: 'vote',
			id    : _this.postId,
			vote  : vote
		};

		$.ajax( {
			data    : objData,
			dataType: 'json',
			type    : 'post',
			url     : CONFIG.vote_url
		} ).done( function ( _data ) {

			if ( _data.success == 1 ) {
				// Handle classes
				_this.$likeBtns .not($currentButton).removeClass( 'active' );
				$currentButton.addClass( 'active' );

				_this.$likesContainer.addClass( 'disabled' );

				// Update count based on ajax
				_this.$likeBtns.filter( '#vote_low' ).find( '.count' ).html( _data.data.low );
				_this.$likeBtns.filter( '#vote_medium' ).find( '.count' ).html( _data.data.medium );
				_this.$likeBtns.filter( '#vote_high' ).find( '.count' ).html( _data.data.high );

				// Set cookie to block like
				Cookies.set( 'article-' + _this.postId, vote, { expires: 365 } );
			}

		} );
	}
}; // SubitoTexto.blogPostLikes